<template>
  <div>{{ item.itemName }}: {{ item.title }} ({{ status }})</div>
</template>

<script>
export default {
  name: "service-list-item",
  props: {
    item: Object,
  },
  computed: {
    status: function() {
      let engineHoursCondition = null;
      let timeCondition = null;
      let engineHoursConditionStr = null;
      let timeConditionStr = null;

      if (this.item.should_be_engine_seconds_before) {
        let dueIn =
          (Number(this.item.should_be_engine_seconds_before) -
            this.item.engine_seconds) /
          3600;
        let absDueIn = Math.abs(dueIn).toFixed(0);

        if (dueIn < 0) {
          engineHoursConditionStr = this.$t(
            "components.serviceListItem.overdueByInEngineHours",
            { due: absDueIn }
          );
          engineHoursCondition = true;
        } else if (absDueIn === "0") {
          engineHoursConditionStr = this.$t(
            "components.serviceListItem.dueNow"
          );
          engineHoursCondition = true;
        } else {
          engineHoursConditionStr = this.$t(
            "components.serviceListItem.dueInEngineHours",
            { due: absDueIn }
          );
        }
      }

      if (this.item.should_be_done_before) {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

        let date = new Date(Date.parse(this.item.should_be_done_before));

        const diffDays = Math.round((date - new Date()) / oneDay);

        const rtf1 = new Intl.RelativeTimeFormat("en", { style: "narrow" });

        if (diffDays <= 0) {
          timeCondition = true;
        }

        timeConditionStr = this.$t("components.serviceListItem.dueDays", {
          days: rtf1.format(diffDays, "day"),
        });
      }

      if (timeCondition) {
        return timeConditionStr;
      }
      if (engineHoursCondition) {
        return engineHoursConditionStr;
      }
      if (engineHoursConditionStr) {
        return engineHoursConditionStr;
      }
      if (timeConditionStr) {
        return timeConditionStr;
      }

      return this.$t("components.serviceListItem.due");
    },
  },
  methods: {},
};
</script>
